import type { Element } from '~/types/shared';

export default function isScrollWithinElementRange(
  { height, distanceFromTop }: Element,
  headerOffset: number,
) {
  if (!height?.value || !distanceFromTop?.value) return false;

  const { scrollTop: scrollOffset } = document.documentElement;

  return (
    scrollOffset >= distanceFromTop.value - (headerOffset || 0) &&
    scrollOffset <= distanceFromTop.value - (headerOffset || 0) + height.value
  );
}
